import { CSSObject, ButtonProps } from '@chakra-ui/react';
import { TTableText } from '../../../types';

export const TableItem: CSSObject = {
  borderBottom: '1px dashed',
  boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.07)',
  borderBottomColor: 'blackAlpha.400',
  borderRight: 'none',
  color: 'white',
  pl: 0,
  py: 2,
  'p:nth-of-type(1)': {
    fontSize: 'xs',
    fontWeight: 'bold',
  },
};
export const TableHeadingText: CSSObject = {
  color: 'white',
};
export const TransactionWrapper: CSSObject = {
  h: 'auto',
};
export const TableText = ({ textVariation }: TTableText): CSSObject => ({
  color: textVariation === 'positive' ? 'alpha.200' : 'white',
  fontSize: '2xs',
});
export const NoTransactionsText: CSSObject = {
  color: 'white',
};
export const buttonMoreTableProps: ButtonProps = {
  variant: 'solid',
};
export const BoxTransactionsContainer: CSSObject = {
  ml: '1',
  color: 'alpha.200',
};
